<div class="card">
  <div class="card-header">Soma de números</div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-4">
        Primeiro número:
        <input
          type="number"
          name="primeiroNumero"
          [(ngModel)]="primeiroNumero"
        />
      </div>
      <div class="col-md-4">
        Segundo número:
        <input type="number" name="segundoNumero" [(ngModel)]="segundoNumero" />
      </div>
      <button class="btn btn-primary" (click)="somarNumeros()">Somar</button>
      <div class="col-md-4">
        <label for="Resultado" *ngIf="resultado > 0"
          >Resultado:{{ resultado }}</label
        >
      </div>
    </div>
  </div>
</div>
